//https://boost.allnetru.dev/api/documentation#/Moderation%20reasons
import { createApi } from '@reduxjs/toolkit/query/react';
import { Options } from 'lib.shared/src/types';
import { baseQueryWithReauth } from '../baseQueryWithReauth';

const moderation_reason = `moderation_reason`;

export const moderationReason = createApi({
  reducerPath: moderation_reason,
  baseQuery: baseQueryWithReauth,
  tagTypes: [moderation_reason],
  endpoints: (build) => ({
    getOrganizerLandingReasons: build.query<{ data: Options }, void>({
      query: () => {
        return {
          url: '/reasons/filter',
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
        };
      },
      providesTags: [moderation_reason],
    }),
  }),
});

export const { useGetOrganizerLandingReasonsQuery } = moderationReason;
